import React, { useEffect, useMemo, useState } from "react";
import "./hourQuestion.css";

const FULL_DAY_RANGE = ["00:00", "23:59"];
const HOUR_REGEX = /^([01]\d|2[0-3]):([0-5]\d)$/;

const toMinutes = (hhmm) => {
  const [hh, mm] = hhmm.split(":").map(Number);
  return hh * 60 + mm;
};

const normalizeTyping = (rawValue) => {
  const digits = String(rawValue || "")
    .replace(/\D/g, "")
    .slice(0, 4);

  if (digits.length <= 2) return digits;
  return `${digits.slice(0, 2)}:${digits.slice(2)}`;
};

const isValidHour = (value) => HOUR_REGEX.test(value);

const isWithinRange = (value, start, end) => {
  const valueMin = toMinutes(value);
  const startMin = toMinutes(start);
  const endMin = toMinutes(end);

  if (startMin <= endMin) {
    return valueMin >= startMin && valueMin <= endMin;
  }

  // Rango cruzando medianoche (ej. 22:00 - 06:00)
  return valueMin >= startMin || valueMin <= endMin;
};

const HourQuestion = ({
  question,
  required = false,
  value = "",
  updateProgress,
  hourRange = null,
}) => {
  const [inputValue, setInputValue] = useState(typeof value === "string" ? value : "");
  const [error, setError] = useState("");

  useEffect(() => {
    setInputValue(typeof value === "string" ? value : "");
  }, [value]);

  const normalizedRange = useMemo(() => {
    if (
      Array.isArray(hourRange) &&
      hourRange.length === 2 &&
      isValidHour(hourRange[0]) &&
      isValidHour(hourRange[1])
    ) {
      return [hourRange[0], hourRange[1]];
    }
    return FULL_DAY_RANGE;
  }, [hourRange]);

  const handleChange = (e) => {
    const nextValue = normalizeTyping(e.target.value);
    setInputValue(nextValue);
    if (error) setError("");
  };

  const handleBlur = () => {
    const nextValue = inputValue.trim();

    if (!nextValue) {
      if (required) {
        setError("Este campo es obligatorio.");
      }
      updateProgress("");
      return;
    }

    if (!isValidHour(nextValue)) {
      setError("Formato invalido. Usa HH:mm.");
      return;
    }

    const [start, end] = normalizedRange;
    if (!isWithinRange(nextValue, start, end)) {
      setError(`La hora debe estar entre ${start} y ${end}.`);
      return;
    }

    setError("");
    setInputValue(nextValue);
    updateProgress(nextValue);
  };

  return (
    <div className="hour-question">
      <label className="question-label">
        {question} {required && <span className="required">*</span>}
      </label>
      <input
        type="text"
        inputMode="numeric"
        className={`hour-input ${error ? "input-error" : ""}`}
        placeholder="HH:mm"
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default HourQuestion;
